module.exports = __webpack_public_path__ + "static/image 5-a45df1c10163295bb4790f41794eb04f.png";